export default "__VITE_ASSET__B4QD_1d7__"